var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-date-picker", {
            staticClass: "filter-item",
            staticStyle: { width: "150px" },
            attrs: {
              type: "date",
              placeholder: "Start Date",
              "value-format": "yyyy-MM-dd",
            },
            model: {
              value: _vm.startDate,
              callback: function ($$v) {
                _vm.startDate = $$v
              },
              expression: "startDate",
            },
          }),
          _c("el-date-picker", {
            staticClass: "filter-item",
            staticStyle: { width: "150px" },
            attrs: {
              type: "date",
              placeholder: "End Date",
              "value-format": "yyyy-MM-dd",
            },
            model: {
              value: _vm.endDate,
              callback: function ($$v) {
                _vm.endDate = $$v
              },
              expression: "endDate",
            },
          }),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "120px" },
              attrs: { placeholder: "Platform", clearable: "" },
              model: {
                value: _vm.listQuery.platform,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "platform", $$v)
                },
                expression: "listQuery.platform",
              },
            },
            [
              _c("el-option", {
                attrs: { label: "Android", value: "android" },
              }),
              _c("el-option", { attrs: { label: "iOS", value: "ios" } }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v(" Search ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { icon: "el-icon-refresh" },
              on: { click: _vm.handleRefresh },
            },
            [_vm._v(" Refresh ")]
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "15px" }, attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _vm._l(_vm.statistics, function (stat, index) {
                return _c(
                  "el-tag",
                  {
                    key: index,
                    staticStyle: { "margin-right": "10px" },
                    attrs: {
                      type: stat.platform === "ios" ? "primary" : "success",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(stat.platform) +
                        ": " +
                        _vm._s(stat.count) +
                        " "
                    ),
                  ]
                )
              }),
              _c(
                "el-tag",
                {
                  staticStyle: { "margin-left": "20px" },
                  attrs: { type: "info" },
                },
                [_vm._v(" Total: " + _vm._s(_vm.total) + " ")]
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.logs,
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "ID", align: "center", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.id) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Platform", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: row.platform === "ios" ? "primary" : "success",
                          size: "small",
                        },
                      },
                      [_vm._v(" " + _vm._s(row.platform) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Created At", align: "center", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(" " + _vm._s(_vm.formatDate(row.createdAt)) + " "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Data Preview", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", { staticClass: "data-preview" }, [
                      _vm._v(" " + _vm._s(row.dataPreview) + " "),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Actions", align: "center", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          size: "small",
                          icon: "el-icon-view",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.showRawData(row)
                          },
                        },
                      },
                      [_vm._v(" View Raw ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          size: "small",
                          icon: "el-icon-document-copy",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.copyData(row)
                          },
                        },
                      },
                      [_vm._v(" Copy ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        staticStyle: { "margin-top": "20px", "text-align": "right" },
        attrs: {
          "current-page": _vm.listQuery.page,
          "page-sizes": [20, 50, 100],
          "page-size": _vm.listQuery.limit,
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Raw Webhook Data",
            visible: _vm.rawDataDialogVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.rawDataDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-descriptions",
            {
              staticStyle: { "margin-bottom": "15px" },
              attrs: { column: 2, border: "", size: "small" },
            },
            [
              _c("el-descriptions-item", { attrs: { label: "Log ID" } }, [
                _vm._v(_vm._s(_vm.selectedLog.id)),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Platform" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type:
                          _vm.selectedLog.platform === "ios"
                            ? "primary"
                            : "success",
                        size: "small",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.selectedLog.platform) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Created At", span: 2 } },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.formatDate(_vm.selectedLog.createdAt)) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "raw-data-container" }, [
            _c("pre", [_vm._v(_vm._s(_vm.formattedRawData))]),
          ]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.rawDataDialogVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.copyRawData } },
                [_vm._v("Copy JSON")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }